import { Button } from '@workspace/ui/components/Button';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useSaveAddress } from '~/hooks/useSaveAddress';

interface SaveButtonProps {
  title?: string;
  className?: string;
  shouldValidateBuilding?: boolean;
  onClick?: (addressId: string) => void;
}

const SaveButton = observer(
  ({ title, className, shouldValidateBuilding, onClick }: SaveButtonProps) => {
    const { t } = useTranslation();
    const { handleSaveAddress, isLoading, isDisabled } = useSaveAddress({
      shouldValidateBuilding,
      onClick,
    });

    return (
      <Button
        variant="primaryOutlined"
        size="xl"
        className={className}
        isLoading={isLoading}
        disabled={isDisabled}
        onClick={handleSaveAddress}
      >
        {title || t('deliverHere')}
      </Button>
    );
  },
);

export default SaveButton;
